import { render, staticRenderFns } from "./App.vue?vue&type=template&id=56324b16&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=56324b16&prod&lang=scss&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=56324b16&prod&lang=scss"
import style2 from "./App.vue?vue&type=style&index=2&id=56324b16&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style2.locals || style2)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "56324b16",
  null
  
)

export default component.exports